import {actions as A} from '../../constants/actions';

const hideUploadingFilePopUp = () => {
  return (dispatch) => {
    dispatch({
      type: A.HIDE_UPLOADING_FILE_POP_UP,
    });
  }
};

export {hideUploadingFilePopUp}
